(() => {
  function activate(root, tab, moveFocus = false) {
    if (!root || !tab) return;
    const panelId = tab.getAttribute('aria-controls');
    root.querySelectorAll('[data-cc-home-tab]').forEach(button => {
      const selected = button === tab;
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    root.querySelectorAll('[data-cc-home-panel]').forEach(panel => { panel.hidden = panel.id !== panelId; });
    root.querySelectorAll('[data-cc-home-view]').forEach(link => { link.hidden = link.dataset.ccHomeView !== panelId; });
    if (moveFocus) tab.focus({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-cc-home-tab]');
    if (tab) activate(tab.closest('[data-cc-collection-tabs]'), tab);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-cc-home-tab]');
    if (!tab || event.ctrlKey || event.metaKey || event.altKey) return;
    const root = tab.closest('[data-cc-collection-tabs]');
    const tabs = [...root.querySelectorAll('[data-cc-home-tab]')];
    const index = tabs.indexOf(tab);
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    activate(root, tabs[next], true);
  });

  document.addEventListener('shopify:block:select', event => {
    const target = event.target;
    const tab = target.matches?.('[data-cc-home-tab]') ? target : target.querySelector?.('[data-cc-home-tab]');
    if (tab) activate(tab.closest('[data-cc-collection-tabs]'), tab);
    const details = target.matches?.('details') ? target : target.closest?.('details');
    if (details) details.open = true;
  });
})();
